import React from 'react';
import { MessageCircle, Phone, Mail, MapPin, ExternalLink } from 'lucide-react';
import { contactData } from '../data/mock';

const Contact = () => {
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${contactData.whatsappNumber}`, '_blank');
  };

  const handleMapsClick = () => {
    window.open(contactData.address.mapsLink, '_blank');
  };

  return (
    <section id="contacto" className="py-20 md:py-32 bg-gradient-to-b from-[rgb(var(--bg-secondary))] to-[rgb(var(--bg-primary))]">
      <div className="container mx-auto px-6 md:px-12 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-6 text-[rgb(var(--burgundy-primary))]">
            {contactData.title}
          </h2>
          <div className="w-20 h-1 bg-[rgb(var(--burgundy-primary))] mx-auto mb-8"></div>
          <p className="body-large text-[rgb(var(--text-secondary))] mb-6 max-w-2xl mx-auto">
            {contactData.subtitle}
          </p>
          <p className="heading-3 text-[rgb(var(--text-primary))] mb-10 font-normal italic">
            "{contactData.ctaPhrase}"
          </p>
        </div>

        {/* Primary CTA Button */}
        <div className="text-center mb-16">
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 px-10 py-5 bg-[rgb(var(--burgundy-primary))] text-white hover:bg-[rgb(var(--burgundy-dark))] transition-smooth button-text text-base shadow-xl hover:shadow-2xl rounded-none"
          >
            <MessageCircle className="w-6 h-6" />
            {contactData.ctaButton}
          </button>
        </div>

        {/* Contact Information Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-[rgb(var(--bg-primary))] p-6 text-center hover-lift">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <Phone className="w-6 h-6 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <h3 className="body-regular font-semibold mb-2 text-[rgb(var(--text-primary))]">
              Teléfono
            </h3>
            <p className="body-small text-[rgb(var(--text-secondary))]">
              {contactData.phone}
            </p>
          </div>

          <div className="bg-[rgb(var(--bg-primary))] p-6 text-center hover-lift">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <Mail className="w-6 h-6 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <h3 className="body-regular font-semibold mb-2 text-[rgb(var(--text-primary))]">
              Email
            </h3>
            <p className="body-small text-[rgb(var(--text-secondary))]">
              {contactData.email}
            </p>
          </div>

          <div className="bg-[rgb(var(--bg-primary))] p-6 text-center hover-lift">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <MapPin className="w-6 h-6 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <h3 className="body-regular font-semibold mb-2 text-[rgb(var(--text-primary))]">
              Ubicación
            </h3>
            <p className="body-small text-[rgb(var(--text-secondary))]">
              {contactData.address.city}
            </p>
          </div>
        </div>

        {/* Detailed Address Card */}
        <div className="bg-[rgb(var(--bg-primary))] p-8 shadow-lg border border-[rgb(var(--border-light))] max-w-3xl mx-auto">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <MapPin className="w-6 h-6 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <div className="flex-1">
              <h3 className="heading-3 mb-3 text-[rgb(var(--burgundy-primary))]">
                Nuestra Ubicación
              </h3>
              <div className="space-y-1 body-regular text-[rgb(var(--text-primary))]">
                <p>{contactData.address.street}</p>
                <p className="body-small text-[rgb(var(--text-secondary))]">
                  {contactData.address.location}
                </p>
                <p>{contactData.address.neighborhood}</p>
                <p>{contactData.address.city}</p>
                <p className="font-medium">{contactData.address.zipCode}</p>
              </div>
              <button
                onClick={handleMapsClick}
                className="mt-4 inline-flex items-center gap-2 text-[rgb(var(--burgundy-primary))] hover:text-[rgb(var(--burgundy-dark))] body-regular font-medium transition-colors"
              >
                <span>Ver en Google Maps</span>
                <ExternalLink className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Google Maps Embed */}
          <div className="mt-6 rounded-none overflow-hidden shadow-md">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3777.1234567890!2d-99.23412345678901!3d18.918765432109876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cddf7a7d5b5b5b%3A0x1234567890abcdef!2sOchoa%20Herrera%20%26%20Asociados!5e0!3m2!1ses!2smx!4v1234567890123!5m2!1ses!2smx"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación Ochoa Herrera & Asociados"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
